interface HeroProps {
  query: string;
  onQueryChange: (value: string) => void;
  onSearch: () => void;
}

const hotTags = ['热血冒险', '治愈日常', '悬疑推理', '奇幻异世界', '青春恋爱'];

export default function Hero({ query, onQueryChange, onSearch }: HeroProps) {
  return (
    <section id="top" className="relative flex min-h-[92vh] w-full items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=stylized%20anime%20comic%20art%20collage%20with%20floating%20manga%20panels%2C%20sketch%20pages%20and%20cute%20character%20silhouettes%2C%20warm%20coral%20red%20and%20cream%20paper%20color%20palette%2C%20playful%20whimsical%20composition%2C%20high%20detail%20digital%20illustration%2C%20soft%20gradient%20background%20with%20gentle%20bokeh%20light%20spots&width=1600&height=900&seq=hero-178&orientation=landscape"
        alt="178漫画网漫画安利推荐背景插画"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/55"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-24 text-center md:px-6">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur-sm">
          <i className="ri-star-smile-fill text-accent-400" aria-hidden="true"></i>
          漫友真实安利 · 编辑部逐部甄选
        </span>

        <h1 className="mt-6 font-heading text-3xl leading-tight text-background-50 md:text-5xl md:leading-tight">
          不知道看什么？
          <span className="block text-accent-400">来178漫画网吃安利</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-50/90 md:text-lg">
          178漫画网安利推荐专区，汇集漫友真实推荐的好漫清单。吃安利、找佳作，每一部都是高质量甄选，帮你快速锁定下一部追更目标。
        </p>

        <form
          className="mx-auto mt-9 flex max-w-xl flex-col gap-2 sm:flex-row"
          role="search"
          onSubmit={(e) => {
            e.preventDefault();
            onSearch();
          }}
        >
          <div className="relative flex-1">
            <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-500" aria-hidden="true"></i>
            <input
              type="search"
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              placeholder="搜索漫画标题、作者或标签…"
              aria-label="搜索漫画"
              className="h-12 w-full rounded-md border border-white/20 bg-background-50/95 pl-11 pr-4 text-sm text-foreground-900 outline-none transition-colors focus:border-accent-400"
            />
          </div>
          <button
            type="submit"
            className="inline-flex h-12 shrink-0 items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始找漫
          </button>
        </form>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
          <span className="text-sm text-background-50/70">大家都在看：</span>
          {hotTags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => {
                onQueryChange(tag);
                onSearch();
              }}
              className="rounded-full border border-white/25 bg-white/10 px-3 py-1.5 text-sm text-background-50 whitespace-nowrap backdrop-blur-sm transition-colors hover:bg-white/20"
            >
              {tag}
            </button>
          ))}
        </div>
      </div>

      <a
        href="#featured"
        aria-label="向下浏览"
        className="absolute bottom-6 left-1/2 flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-full bg-background-50/15 text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/30"
      >
        <i className="ri-arrow-down-line animate-bounce" aria-hidden="true"></i>
      </a>
    </section>
  );
}